import { useMemo } from 'react'
import { useOpeningHours } from 'shared/utils/useOpeningHours'
import { isDaySelectable, isTimeSelectable } from 'ui/components/Picker/utils'
import { useCart } from 'shop-components/utils/useCart'
import _every from 'lodash/every'

export const useDateValidation = () => {
  const { cart } = useCart()
  const openingHours = useOpeningHours()

  const isDateValid = useMemo(() => {
    if (!cart?.starts_at || !cart?.stops_at) {
      return false
    }

    const dates = {
      starts_at: cart.starts_at,
      stops_at: cart.stops_at
    }

    const isStartDateValid = isDaySelectable({
      type: 'start',
      openingHours,
      date: dates.starts_at,
      values: dates
    })

    const isStopDateValid = isDaySelectable({
      type: 'stop',
      openingHours,
      date: dates.stops_at,
      values: dates
    })

    const isStartTimeValid = isTimeSelectable({
      type: 'start',
      openingHours,
      values: dates
    })

    const isStopTimeValid = isTimeSelectable({
      type: 'stop',
      openingHours,
      values: dates
    })

    return _every([isStartDateValid, isStopDateValid, isStartTimeValid, isStopTimeValid])
  }, [cart?.starts_at, cart?.stops_at, openingHours])

  return isDateValid
}
